import { render, staticRenderFns } from "./AppFormItem.vue?vue&type=template&id=12bdae5c"
import script from "./AppFormItem.vue?vue&type=script&lang=ts"
export * from "./AppFormItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_css-loader@6.8.1_webpack@5_c778bbf21d678b30ebccd90a1f5b0b7e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports